// src/hooks/useScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const scrollWindowToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
};

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollWindowToTop();
  }, [pathname]);
};
